import { DeleteOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons'
import { usePosts } from '@entities/post'
import type { Post } from '@entities/post/model/types'
import { usePaletteColors } from '@shared/hooks/use-palette-colors'
import { dateToShortString } from '@shared/lib/dateToShortString/dateToShortString'
import { dayjs } from '@shared/lib/dayjs/dayjs'
import { Button, Flex, theme, Typography } from 'antd'
import { Dialog } from 'antd-mobile'
import { useState } from 'react'
import { ChevronDown } from 'react-feather'
import { MessageView } from '../message-view/message-view'
import * as styles from './mobile-post.module.scss'

const { Text } = Typography

interface MobilePostProps {
    post: Post
    onEdit?: (post: Post) => void
}

export const MobilePost = ({ post, onEdit }: MobilePostProps) => {
    const {
        token: { colorPrimary, colorError }
    } = theme.useToken()

    const [collapsed, setCollapsed] = useState(true)

    const paletteColors = usePaletteColors(post.postType?.color)

    const {
        actions: { deletePost, preparePostForTgShare }
    } = usePosts()

    return (
        <div
            className={styles.mobilePost}
            style={{ backgroundColor: paletteColors?.[0], borderColor: paletteColors?.[2] }}
        >
            <div className={styles.mobilePostContainer}>
                <Flex align="center" gap={6}>
                    <Text className={styles.circle} style={{ color: colorPrimary }}>
                        ○
                    </Text>
                    {(post.state === 'planned' || post.state === 'published') && (
                        <Text className={styles.publishedTime}>{dayjs(post.publishDate).format('HH:mm')}</Text>
                    )}

                    <Text style={{ fontSize: '17px' }}>{post.postType?.name || 'Нет типа'}</Text>
                    <ChevronDown
                        style={{ marginLeft: 'auto', transform: !collapsed ? 'rotate(180deg)' : undefined }}
                        onClick={() => setCollapsed((prev) => !prev)}
                    />
                </Flex>

                <Flex justify="space-between">
                    <Text>{post.creator.username}</Text>
                    <Text style={{ color: colorPrimary }}>{dateToShortString(post.createdAt)}</Text>
                </Flex>
            </div>

            {!collapsed && (
                <>
                    {post.messages.map((item) => (
                        <MessageView message={item} key={item.id} />
                    ))}

                    <Flex gap={2} justify="flex-end" className={styles.mobilePostContainer}>
                        <Button
                            type="text"
                            style={{ padding: '4px' }}
                            onClick={() => {
                                preparePostForTgShare(post.id).then((messageId) => {
                                    Telegram.WebApp.shareMessage(messageId, (ok: unknown) => {
                                        if (ok) console.log('Сообщение отправлено')
                                        else console.error('Не удалось отправить сообщение')
                                    })
                                })
                            }}
                        >
                            <UploadOutlined style={{ fontSize: 20, color: colorPrimary }} />
                        </Button>
                        {onEdit && (
                            <Button type="text" style={{ padding: '4px' }} onClick={() => onEdit(post)}>
                                <EditOutlined style={{ fontSize: 20, color: colorPrimary }} />
                            </Button>
                        )}
                        <Button
                            type="text"
                            style={{ padding: '4px' }}
                            onClick={() =>
                                Dialog.confirm({
                                    content: 'Вы уверены что хотите удалить пост?',
                                    cancelText: 'Отмена',
                                    confirmText: 'Удалить',
                                    onConfirm: () => deletePost(post.id)
                                })
                            }
                        >
                            <DeleteOutlined style={{ fontSize: 20, color: colorError }} />
                        </Button>
                    </Flex>
                </>
            )}
        </div>
    )
}
